// Bandierine dei cantieri della giornata, condivise fra la mappa in dashboard
// e la vista completa di localizzazione mezzi.

const FLAG_SVG =
  "M6 2v20M6 3h11l-2.2 3.5L17 10H6";

// I cantieri censiti prima dell'integrazione con Google non hanno lat/lng:
// li si geocodifica al volo dall'indirizzo, tenendo il risultato in memoria
// per non ripetere la chiamata a ogni refresh della pagina.
const geocodeCache = new Map();

function geocodeAddress(maps, address) {
  if (geocodeCache.has(address)) return Promise.resolve(geocodeCache.get(address));
  return new Promise((resolve) => {
    try {
      new maps.Geocoder().geocode({ address, region: "it" }, (res, status) => {
        const loc = status === "OK" && res?.[0]?.geometry?.location;
        const out = loc ? { lat: loc.lat(), lng: loc.lng() } : null;
        geocodeCache.set(address, out);
        resolve(out);
      });
    } catch { resolve(null); }
  });
}

export function siteFlagIcon(maps) {
  return {
    path: FLAG_SVG,
    fillColor: "#0067b2",
    fillOpacity: 1,
    strokeColor: "#0067b2",
    strokeWeight: 2,
    scale: 1.1,
    anchor: new maps.Point(6, 22),
  };
}

export function siteInfoHtml(site) {
  const rows = [
    site.address,
    site.client,
    [site.employees_count != null ? `${site.employees_count} persone` : null,
     site.equipment_count != null ? `${site.equipment_count} mezzi` : null]
      .filter(Boolean).join(" · "),
  ].filter(Boolean);
  return `<div style="font-family:sans-serif;padding:2px 4px;max-width:220px;">
      <div style="font-weight:700;font-size:13px;">${site.name || "Cantiere"}</div>
      ${rows.map(r => `<div style="font-size:11px;color:#64748B;margin-top:2px;">${r}</div>`).join("")}
    </div>`;
}

/**
 * Disegna un marker a bandierina per ogni cantiere, geocodificando gli
 * indirizzi privi di coordinate. Restituisce i marker creati.
 */
export async function renderSiteMarkers(maps, map, sites, { onClick, bounds } = {}) {
  const markers = [];
  for (const site of sites || []) {
    let pos = site.lat && site.lng ? { lat: site.lat, lng: site.lng } : null;
    if (!pos && site.address) pos = await geocodeAddress(maps, site.address);
    if (!pos) continue;
    const marker = new maps.Marker({
      position: pos, map, title: site.name,
      icon: siteFlagIcon(maps), zIndex: 999,
    });
    if (onClick) marker.addListener("click", () => onClick(site, marker));
    if (bounds) bounds.extend(pos);
    markers.push(marker);
  }
  return markers;
}
